import { Loader2 } from "lucide-react"
import { Button } from "components/ui/button"

type WaitingScreenProps = {
  meetingTitle: string
  requesting: boolean
  onLeave: () => void
}

/** Shown to knocking attendees between requesting access and the host's decision. */
export function WaitingScreen({ meetingTitle, requesting, onLeave }: WaitingScreenProps) {
  return (
    <div data-testid="call-waiting" className="flex h-full w-full items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-2xl bg-[#151d26] p-6 text-center ring-1 ring-white/10">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-[#f6a35c]" />
        <h2 className="mt-4 text-lg font-semibold text-white">
          {requesting ? "Requesting access..." : "Waiting for the host to admit you"}
        </h2>
        <p className="mt-2 text-sm text-white/70">{meetingTitle}</p>
        <p className="mt-2 text-xs text-white/60">You will enter the meeting automatically when admitted.</p>
        <Button type="button" variant="secondary" onClick={onLeave} className="mt-5 w-full">
          Leave
        </Button>
      </div>
    </div>
  )
}
